import { Sections } from '@/shared/libs/sdk';
import { getSubscriberRating } from '@/shared/utils';
import { SectionLayout } from '@/shared/enums';

export default {
  data() {
    return {
      subscriber: this.$services.resolve('subscriber'),
      sections: [],
    };
  },
  beforeDestroy() {
    this.$store.commit('SET_PAGE_WITH_HERO', false);
  },
  methods: {
    fetchSections(options = {}) {
      const maxRating = getSubscriberRating(this.subscriber.dateOfBirth);
      const id = options.id;
      const label = options.label || this.$route.meta.label;
      const category = options.category;
      const kids = this.subscriber.isKidsTheme;

      return new Sections({ id, label, category }).fetchAll({ kids, maxRating })
        .then((sections) => {
          const availableLayouts = Object.keys(SectionLayout);
          this.sections = sections.filter(({ layout }) => availableLayouts.includes(layout));
          this.$store.commit('SET_PAGE_WITH_HERO', this.hasFirstHero(sections));
        });
    },

    hasFirstHero(sections) {
      return [SectionLayout.HERO, SectionLayout.HERO_SIMPLE].includes(sections[0]?.layout);
    },
  },
};
